import { useEffect } from 'react';

/**
 * Calls `onEscape` whenever the Escape key is pressed.
 * Pass `enabled = false` to temporarily disable (e.g. during submission).
 */
const useEscapeKey = (onEscape, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e) => {
      if (e.key === 'Escape') onEscape();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onEscape, enabled]);
};

export default useEscapeKey;
